module.exports = __webpack_public_path__ + "img/20190603162112068.78be92e0.png";